import { Avatar, Clickable, Col, Icon, Row, Text } from 'components';
import { Api, theme } from 'lib';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

const SearchItem = ({ item, fromSearch }) => {
  const navigate = useNavigate(),
    dispatch = useDispatch(),
    { t } = useTranslation();

  item = item.target || item;

  function handleGetApp() {
    dispatch({
      type: 'UPDATE_APP_STATE',
      payload: {
        showGetApp: true
      }
    });
  }

  function handleSelect() {
    const type = item?.tag || item.type === 'tag' ? 'tag' : 'user';

    if (fromSearch) {
      const data = {
        type,
        target: item,
        updatedAt: new Date()
      };

      dispatch({
        type: 'ADD_SEARCH_ITEM',
        payload: data
      });

      Api.put('/users/addRecentSearch', { type, targetId: item._id, text: item?.tag });
    }

    switch (type) {
      case 'user':
        return navigate(`/profile/${item.username}`);
      case 'tag':
        return handleGetApp();
      default:
        return;
    }
  }

  function removeSearch() {
    dispatch({
      type: 'REMOVE_SEARCH_ITEM',
      payload: item
    });

    Api.post('/users/removeSearch', { targetId: item._id });
  }

  if (item?.tag || item?.text)
    return (
      <Clickable onClick={handleSelect}>
        <Row between pad="0 16px 8px">
          <Row>
            <Row centerAll wid="72px" ht="72px" bg={theme.GREY_10} hasRadius="72px" noFlex>
              <Row centerAll wid="68px" ht="68px" bg="#fff" hasRadius="68px" noFlex>
                <Row centerAll wid="64px" ht="64px" bg={theme.GREY_10} hasRadius="64px" noFlex>
                  <Text h4>#</Text>
                </Row>
              </Row>
            </Row>

            <Col noFlex marg="0 0 0 16px" center>
              <Col noFlex>
                <Text bold marg="0 0 2px 0">
                  {item.tag || item.text}
                </Text>

                <Text b2 col={theme.GREY_60} wid="240px">
                  {t(item.count !== 1 ? 'browse.postCountPlural' : 'browse.postCountSingular', {
                    count: item.count
                  })}
                </Text>
              </Col>
            </Col>
          </Row>

          {!fromSearch && (
            <Col noFlex center>
              <Clickable onClick={removeSearch}>
                <Icon type="close" col={theme.GREY_60} dimensions={14} />
              </Clickable>
            </Col>
          )}
        </Row>
      </Clickable>
    );

  if (item?.username || item?.target?.username)
    return (
      <Clickable onClick={handleSelect}>
        <Row between pad="0 16px 8px">
          <Row>
            <Avatar user={item} />

            <Col noFlex marg="0 0 0 16px" center>
              <Col noFlex>
                <Text bold marg={item.bio && '0 0 2px 0'}>
                  {item.name}
                </Text>

                {!!item.bio && (
                  <Text b2 col={theme.GREY_60} numberOfLines={1} wid="240px">
                    {item.bio}
                  </Text>
                )}
              </Col>
            </Col>
          </Row>

          {!fromSearch && (
            <Col noFlex center>
              <Clickable onClick={removeSearch}>
                <Icon type="close" col={theme.GREY_60} dimensions={14} />
              </Clickable>
            </Col>
          )}
        </Row>
      </Clickable>
    );

  return null;
};

export default SearchItem;
